import { Tabs } from 'antd'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ContentContainer } from '../../components/custom_components/ContentContainer'
import PerFlexRow from '../../components/custom_components/FlexRow'
import { PerTabBarContent } from '../../components/custom_components/TabBarContent'
import { useAuth } from '../../context/auth-context'
import { hasPermission } from '../../shared/permissions/permission-helper'
import { EmployeeMeetingsContainer } from './EmployeeMeetingsContainer'
import { ManagerMeetingsContainer } from './ManagerMeetingsContainer'
import { RequestedMeetingsContainer } from './RequestedMeetingsContainer'
import { SubordinateMeetingsContainer } from './SubordinateMeetingsContainer'
import { MeetingsPagePermissions } from './permissions'
import { useCollapse } from '../../routes/collapse-context'

const { TabPane } = Tabs

export const MeetingsPage: FC = () => {
  const getDefaultActiveKey = () => {
    return window.location.hash === '#my-meetings' ? '3' : '1'
  }

  const [activeKey, setActiveKey] = useState(getDefaultActiveKey())

  const [t] = useTranslation()
  const { user } = useAuth()
  const collapsed = useCollapse()

  const userRoles = user.roles

  return (
    <ContentContainer collapsed={collapsed}>
      {hasPermission(MeetingsPagePermissions.reviewerMeetings, userRoles ? userRoles : []) ? (
        <PerFlexRow justify="end">
          <Tabs
            activeKey={activeKey}
            className="fullWidth"
            renderTabBar={() => (
              <PerTabBarContent
                tabs={
                  <Tabs onChange={(key) => setActiveKey(key)} defaultActiveKey={activeKey}>
                    <TabPane tab={t('meetingView.managerMeetings.tab')} key="1" />
                    <TabPane tab={t('meetingView.requestedMeetings.tab')} key="2" />
                    {hasPermission(MeetingsPagePermissions.subordinateMeetings, userRoles ? userRoles : []) && (
                      <TabPane tab={t('meetingView.allMeetings.tab')} key="4" />
                    )}
                    <TabPane tab={<span data-e2e-my-meetings-tab>{t('meetingView.ownMeetings.tab')}</span>} key="3" />
                  </Tabs>
                }
              />
            )}
          >
            <TabPane key="1">
              <ManagerMeetingsContainer />
            </TabPane>
            <TabPane key="2">
              <RequestedMeetingsContainer />
            </TabPane>
            <TabPane key="4">
              <SubordinateMeetingsContainer />
            </TabPane>
            <TabPane key="3">
              <EmployeeMeetingsContainer />
            </TabPane>
          </Tabs>
        </PerFlexRow>
      ) : (
        <EmployeeMeetingsContainer />
      )}
    </ContentContainer>
  )
}
